import React, { Component } from "react";
import { app } from "./Global.module.css";
import { Redirect, Route, Switch } from "react-router-dom";
import Routes from "./routes.json";
import SlidesPage from "./pages/SlidesPage";
import EditorPage from "./pages/EditorPage";
import ViewPage from "./pages/ViewPage";
import ErrorPage from "./pages/ErrorPage";
import LoginPage from "./pages/LoginPage";
import { isLoggedin } from "./helpers/auth";
import InfoBar from "./components/reusable/InfoBar/InfoBar";

export default class App extends Component {
	state = {
		infoBar: {},
	};

	componentDidMount = () => {
		window.addEventListener("offline", (event) => {
			this.setState({
				infoBar: {
					message: "No internet connection detected!",
					severity: "error",
				},
			});
		});

		window.addEventListener("online", (event) => {
			this.setState({
				infoBar: {
					message: "You are online now!",
					severity: "success",
				},
			});
		});
	};

	closeInfoBar = () => {
		this.setState({
			infoBar: {},
		});
	};

	render() {
		return (
			<div className={app}>
				{this.state.infoBar.message && this.state.infoBar.severity && (
					<InfoBar
						message={this.state.infoBar.message}
						severity={this.state.infoBar.severity}
						onClose={this.closeInfoBar}
					/>
				)}
				<Switch>
					<PrivateRoute
						exact
						path={Routes.SlidesPage}
						component={SlidesPage}
					/>
					<PrivateRoute
						exact
						path={Routes.EditorPage + "/:id"}
						component={EditorPage}
					/>
					<Route
						exact
						path={Routes.ViewPage + "/:id"}
						component={ViewPage}
					/>
					<Route
						exact
						path={Routes.LoginPage}
						render={(props) => <LoginPage {...props} />}
					/>
					<Route component={ErrorPage} />
				</Switch>
			</div>
		);
	}
}

const PrivateRoute = ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={(props) =>
				isLoggedin() ? (
					<Component {...props} />
				) : (
					<Redirect
						to={{
							pathname: Routes.LoginPage,
							state: { from: window.location.href },
						}}
					/>
				)
			}
		/>
	);
};
